var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", grow: "", shrink: "" } },
    [
      _c(
        "w-row",
        { attrs: { center: "" } },
        [
          _vm._t("default"),
          _c(
            "div",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.notAllowedToView },
                          on: {
                            click: function ($event) {
                              return _vm.showScriptInfo()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "eye" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            [
              _c("w-data-table", {
                style: { flexGrow: 1 },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.scripts,
                  "selected-items": _vm.selectedRows,
                  compare: _vm.compare,
                },
                on: {
                  "item-clicked": function ($event) {
                    return _vm.showScriptInfo($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }